// import Image from 'next/image';
// import Link from 'next/link';
// import React, { useState } from 'react';

// import Table from '../../../elements/table';
// import PageLoader from '../../page-loader';

// import { getFullDate } from '../../../../utils/formatters';
// import { useCookies } from 'react-cookie';
// import Loader from '../../../elements/loader';
// import {
//   activateCoupons,
//   deactivateCoupons,
//   deleteCoupons,
// } from '../../../../api-client/my-product';
// import { toast } from 'react-toastify';

// const CustomerListTable = ({
//   stats,
//   setOpenCouponListModal,
//   setEditCouponModal,
//   setCurrentProduct,
// }) => {
//   const [cookie, setCookie] = useCookies();
//   const dataTable = React.useMemo(() => {
//     return stats;
//   }, [stats]);

//   const column = React.useMemo(() => {
//     return [
//       {
//         Header: 'Products',
//         accessor: 'name',
//         Cell: ({ row }) => {
//           const { name } = row.original.products;

//           return name?.map(product => (
//             <>
//               <small key={product}>{product}</small> <br />
//             </>
//           ));
//         },
//       },
//       {
//         Header: 'Start/End Date',
//         accessor: 'startDate',
//         Cell: ({ row }) => (
//           <div>
//             <div>{getFullDate(row.values.startDate)}</div>
//             <div>{getFullDate(row.values.endDate)}</div>
//           </div>
//         ),
//       },
//       {
//         Header: 'Discount/Discount Type',
//         accessor: 'discount',
//         Cell: ({ row }) => {
//           return (
//             <div>
//               <div>
//                 {row.original.discountType === 'amount'
//                   ? `$${row.values.discount}`
//                   : `${row.values.discount}%`}
//               </div>
//               <div className="text-link-text">{row.original.discountType}</div>
//             </div>
//           );
//         },
//       },
//       {
//         Header: 'Coupon Code',
//         accessor: 'couponCode',
//       },
//       {
//         Header: '',
//         accessor: 'icons',
//         Cell: ({ row }) => {
//           const [delLoading, setDelLoading] = useState(false);
//           const [deActivateLoading, setDeactivateLoading] = useState(false);
//           const [activateLoading, setActivateLoading] = useState(false);

//           // Handle Delete Coupon
//           const handleDelete = async data => {
//             setDelLoading(true);

//             try {
//               const res = await deleteCoupons(data);
//               toast.success(res.data.message);
//               setDelLoading(false);
//               setOpenCouponListModal(false);
//             } catch (error) {
//               console.log(error);
//             }
//           };

//           // Handle Deactivate Coupon
//           const handleDeactivate = async data => {
//             setDeactivateLoading(true);

//             try {
//               const res = await deactivateCoupons(data);
//               toast.success(res.data.message);
//               setDeactivateLoading(false);
//               setOpenCouponListModal(false);
//             } catch (error) {
//               console.log(error);
//               setDeactivateLoading(false);
//             }
//           };

//           // Handle Activate Coupon
//           const handleActivate = async data => {
//             setActivateLoading(true);

//             try {
//               const res = await activateCoupons(data);
//               toast.success(res.data.message);
//               setActivateLoading(false);
//               setOpenCouponListModal(false);
//             } catch (error) {
//               console.log(error);
//               setActivateLoading(false);
//             }
//           };

//           return (
//             <div className="flex justify-center">
//               <div>
//                 <button
//                   onClick={() => {
//                     setEditCouponModal(true);
//                     setCurrentProduct(row.original);
//                   }}
//                 >
//                   <span
//                     className="material-icons text-neutral-mid-80"
//                     title="Edit"
//                   >
//                     edit
//                   </span>
//                 </button>
//               </div>
//               <div className="ml-4">
//                 <button
//                   onClick={() => {
//                     const data = {
//                       code: row.values.couponCode,
//                       authToken: cookie.authToken,
//                     };
//                     handleDelete(data);
//                   }}
//                 >
//                   {delLoading ? (
//                     <Loader />
//                   ) : (
//                     <span
//                       className="material-icons text-red-400"
//                       title="Delete"
//                     >
//                       delete
//                     </span>
//                   )}
//                 </button>
//               </div>
//               <div className="ml-4">
//                 {row.original.active ? (
//                   <button
//                     onClick={() => {
//                       const data = {
//                         code: row.values.couponCode,
//                         authToken: cookie.authToken,
//                       };
//                       handleDeactivate(data);
//                     }}
//                   >
//                     {deActivateLoading ? (
//                       <Loader />
//                     ) : (
//                       <span
//                         className="material-icons text-warn"
//                         title="Deactivate Coupon"
//                       >
//                         block
//                       </span>
//                     )}
//                   </button>
//                 ) : (
//                   <button
//                     onClick={() => {
//                       const data = {
//                         code: row.values.couponCode,
//                         authToken: cookie.authToken,
//                       };
//                       handleActivate(data);
//                     }}
//                   >
//                     {activateLoading ? (
//                       <Loader />
//                     ) : (
//                       <span
//                         className="material-icons text-secondary"
//                         title="Activate Coupon"
//                       >
//                         check_circle
//                       </span>
//                     )}
//                   </button>
//                 )}
//               </div>
//             </div>
//           );
//         },
//       },
//     ];
//   }, []);

//   return (
//     <>
//       <Table columns={column} data={dataTable} />
//     </>
//   );
// };

// export { CustomerListTable };

import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";

import Table from "../../../elements/table";
import PageLoader from "../../page-loader";

import { getFullDate } from "../../../../utils/formatters";
import { useCookies } from "react-cookie";
import Loader from "../../../elements/loader";
import {
  activateCoupons,
  deactivateCoupons,
  deleteCoupons,
} from "../../../../api-client/my-product";
import { toast } from "react-toastify";
import { Deactivate } from "../../../../public/assets/icons";

const CustomerListTable = ({
  stats,
  setOpenCouponListModal,
  setEditCouponModal,
  setCurrentProduct,
}) => {
  const [cookie, setCookie] = useCookies();
  const dataTable = React.useMemo(() => {
    return stats;
  }, [stats]);

  const column = React.useMemo(() => {
    return [
      {
        Header: "Products",
        accessor: "name",
        Cell: ({ row }) => {
          const { name } = row.original.products;

          return name?.map((product) => (
            <React.Fragment key={product}>
              <small>{product}</small> <br />
            </React.Fragment>
          ));
        },
      },
      {
        Header: "Start/End Date",
        accessor: "startDate",
        Cell: ({ row }) => (
          <div>
            <div>{getFullDate(row.values.startDate)}</div>
            <div>{getFullDate(row.values.endDate)}</div>
          </div>
        ),
      },
      {
        Header: "Discount/Discount Type",
        accessor: "discount",
        Cell: ({ row }) => {
          return (
            <div>
              <div>
                {row.original.discountType === "amount"
                  ? `$${row.values.discount}`
                  : `${row.values.discount}%`}
              </div>
              <div className="text-link-text">{row.original.discountType}</div>
            </div>
          );
        },
      },
      {
        Header: "Coupon Code",
        accessor: "couponCode",
      },
      {
        Header: "",
        accessor: "icons",
        Cell: ({ row }) => {
          const [dropdownVisible, setDropdownVisible] = useState(false);
          const [delLoading, setDelLoading] = useState(false);
          const [deActivateLoading, setDeactivateLoading] = useState(false);
          const [activateLoading, setActivateLoading] = useState(false);

          // Handle Delete Coupon
          const handleDelete = async (data) => {
            setDelLoading(true);

            try {
              const res = await deleteCoupons(data);
              toast.success(res.data.message);
              setDelLoading(false);
              setOpenCouponListModal(false);
            } catch (error) {
              console.log(error);
            }
          };

          // Handle Deactivate Coupon
          const handleDeactivate = async (data) => {
            setDeactivateLoading(true);

            try {
              const res = await deactivateCoupons(data);
              toast.success(res.data.message);
              setDeactivateLoading(false);
              setOpenCouponListModal(false);
            } catch (error) {
              console.log(error);
              setDeactivateLoading(false);
            }
          };

          // Handle Activate Coupon
          const handleActivate = async (data) => {
            setActivateLoading(true);

            try {
              const res = await activateCoupons(data);
              toast.success(res.data.message);
              setActivateLoading(false);
              setOpenCouponListModal(false);
            } catch (error) {
              console.log(error);
              setActivateLoading(false);
            }
          };

          return (
            <div className=" flex justify-center">
              <button onClick={() => setDropdownVisible(!dropdownVisible)}>
                <span
                  className="material-icons text-neutral-mid-80"
                  title="More"
                >
                  more_vert
                </span>
              </button>
              {dropdownVisible && (
                <div className="absolute right-0 mt-2 py-3 w-48 rounded-tl-[24px] rounded-br-[24px] bg-white border rounded-md shadow-lg z-50">
                  <button
                    className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => {
                      setEditCouponModal(true);
                      setCurrentProduct(row.original);
                      setDropdownVisible(false);
                    }}
                  >
                    <div className="flex items-center my-3 ">
                      <span
                        className="material-icons text-neutral-mid-80"
                        title="Edit"
                      >
                        edit
                      </span>
                      <p className="ml-3">Edit</p>
                    </div>
                  </button>
                  <button
                    className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100 "
                    onClick={() => {
                      const data = {
                        code: row.values.couponCode,
                        authToken: cookie.authToken,
                      };
                      handleDelete(data);
                      setDropdownVisible(false);
                    }}
                  >
                    {delLoading ? (
                      <Loader />
                    ) : (
                      <div className="flex items-center my-3 ">
                        <span
                          className="material-icons text-red-400"
                          title="Delete"
                        >
                          delete
                        </span>
                        <p className="ml-3">Delete</p>
                      </div>
                    )}
                  </button>
                  {row.original.active ? (
                    <button
                      className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                      onClick={() => {
                        const data = {
                          code: row.values.couponCode,
                          authToken: cookie.authToken,
                        };
                        handleDeactivate(data);
                        setDropdownVisible(false);
                      }}
                    >
                      {deActivateLoading ? (
                        <Loader />
                      ) : (
                        <div className="flex items-center my-3 ">
                          <span
                            className="material-icons text-secondary"
                            title="Deactivate Coupon"
                          >
                            <Image
                              src={Deactivate}
                              alt="deactivate"
                              width={25}
                              height={25}
                              className="w-auto"
                            />
                          </span>
                          <p className="ml-3">Deactivate</p>
                        </div>
                      )}
                    </button>
                  ) : (
                    <button
                      className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                      onClick={() => {
                        const data = {
                          code: row.values.couponCode,
                          authToken: cookie.authToken,
                        };
                        handleActivate(data);
                        setDropdownVisible(false);
                      }}
                    >
                      {activateLoading ? (
                        <Loader />
                      ) : (
                        <div className="flex items-center my-3 ">
                          <span
                            className="material-icons text-secondary"
                            title="Activate Coupon"
                          >
                            check_circle
                          </span>
                          <p className="ml-3">Activate</p>
                        </div>
                      )}
                    </button>
                  )}
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }, []);

  return (
    <>
      <Table columns={column} data={dataTable} />
    </>
  );
};

export { CustomerListTable };

// import Image from 'next/image';
// import Link from 'next/link';
// import React, { useState } from 'react';

// import Table from '../../../elements/table';
// import PageLoader from '../../page-loader';

// import { getFullDate } from '../../../../utils/formatters';
// import { useCookies } from 'react-cookie';
// import Loader from '../../../elements/loader';
// import {
//   activateCoupons,
//   deactivateCoupons,
//   deleteCoupons,
// } from '../../../../api-client/my-product';
// import { toast } from 'react-toastify';

// const CustomerListTable = ({
//   stats,
//   setOpenCouponListModal,
//   setEditCouponModal,
//   setCurrentProduct,
// }) => {
//   const [cookie, setCookie] = useCookies();
//   const dataTable = React.useMemo(() => {
//     return stats;
//   }, [stats]);

//   const column = React.useMemo(() => {
//     return [
//       {
//         Header: 'Products',
//         accessor: 'name',
//         Cell: ({ row }) => {
//           const { name } = row.original.products;

//           return name?.map(product => (
//             <>
//               <small key={product}>{product}</small> <br />
//             </>
//           ));
//         },
//       },
//       {
//         Header: 'Start/End Date',
//         accessor: 'startDate',
//         Cell: ({ row }) => (
//           <div>
//             <div>{getFullDate(row.values.startDate)}</div>
//             <div>{getFullDate(row.values.endDate)}</div>
//           </div>
//         ),
//       },
//       {
//         Header: 'Discount/Discount Type',
//         accessor: 'discount',
//         Cell: ({ row }) => {
//           return (
//             <div>
//               <div>
//                 {row.original.discountType === 'amount'
//                   ? `$${row.values.discount}`
//                   : `${row.values.discount}%`}
//               </div>
//               <div className="text-link-text">{row.original.discountType}</div>
//             </div>
//           );
//         },
//       },
//       {
//         Header: 'Coupon Code',
//         accessor: 'couponCode',
//       },
//       {
//         Header: '',
//         accessor: 'icons',
//         Cell: ({ row }) => {
//           const [delLoading, setDelLoading] = useState(false);
//           const [deActivateLoading, setDeactivateLoading] = useState(false);
//           const [activateLoading, setActivateLoading] = useState(false);
//           const [showActions, setShowActions] = useState(false); // State to toggle actions

//           // Handle Delete Coupon
//           const handleDelete = async data => {
//             setDelLoading(true);

//             try {
//               const res = await deleteCoupons(data);
//               toast.success(res.data.message);
//               setDelLoading(false);
//               setOpenCouponListModal(false);
//             } catch (error) {
//               console.log(error);
//             }
//           };

//           // Handle Deactivate Coupon
//           const handleDeactivate = async data => {
//             setDeactivateLoading(true);

//             try {
//               const res = await deactivateCoupons(data);
//               toast.success(res.data.message);
//               setDeactivateLoading(false);
//               setOpenCouponListModal(false);
//             } catch (error) {
//               console.log(error);
//               setDeactivateLoading(false);
//             }
//           };

//           // Handle Activate Coupon
//           const handleActivate = async data => {
//             setActivateLoading(true);

//             try {
//               const res = await activateCoupons(data);
//               toast.success(res.data.message);
//               setActivateLoading(false);
//               setOpenCouponListModal(false);
//             } catch (error) {
//               console.log(error);
//               setActivateLoading(false);
//             }
//           };

//           return (
//             <div className="flex justify-center  relative">
//               <div>
//                 <button
//                   onClick={() => setShowActions(!showActions)} // Toggle actions on click
//                 >
//                   <span
//                     className="material-icons text-neutral-mid-80"
//                     title="Show Actions"
//                   >
//                     more_vert
//                   </span>
//                 </button>
//               </div>
//               {showActions && ( // Conditionally render actions
//                 <div className="flex flex-row my-5">
//                   <div>
//                     <button
//                       onClick={() => {
//                         setEditCouponModal(true);
//                         setCurrentProduct(row.original);
//                       }}
//                     >
//                       <span
//                         className="material-icons text-neutral-mid-80"
//                         title="Edit"
//                       >
//                         edit
//                       </span>
//                     </button>
//                   </div>
//                   <div className="ml-4">
//                     <button
//                       onClick={() => {
//                         const data = {
//                           code: row.values.couponCode,
//                           authToken: cookie.authToken,
//                         };
//                         handleDelete(data);
//                       }}
//                     >
//                       {delLoading ? (
//                         <Loader />
//                       ) : (
//                         <span
//                           className="material-icons text-red-400"
//                           title="Delete"
//                         >
//                           delete
//                         </span>
//                       )}
//                     </button>
//                   </div>
//                   <div className="ml-4">
//                     {row.original.active ? (
//                       <button
//                         onClick={() => {
//                           const data = {
//                             code: row.values.couponCode,
//                             authToken: cookie.authToken,
//                           };
//                           handleDeactivate(data);
//                         }}
//                       >
//                         {deActivateLoading ? (
//                           <Loader />
//                         ) : (
//                           <span
//                             className="material-icons text-warn"
//                             title="Deactivate Coupon"
//                           >
//                             block
//                           </span>
//                         )}
//                       </button>
//                     ) : (
//                       <button
//                         onClick={() => {
//                           const data = {
//                             code: row.values.couponCode,
//                             authToken: cookie.authToken,
//                           };
//                           handleActivate(data);
//                         }}
//                       >
//                         {activateLoading ? (
//                           <Loader />
//                         ) : (
//                           <span
//                             className="material-icons text-secondary"
//                             title="Activate Coupon"
//                           >
//                             check_circle
//                           </span>
//                         )}
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>
//           );
//         },
//       },
//     ];
//   }, []);

//   return (
//     <>
//       <Table columns={column} data={dataTable} />
//     </>
//   );
// };

// export { CustomerListTable };
